import { render, staticRenderFns } from "./VendasPeriodo.vue?vue&type=template&id=3a497c6c&scoped=true"
import script from "./VendasPeriodo.vue?vue&type=script&lang=js"
export * from "./VendasPeriodo.vue?vue&type=script&lang=js"
import style0 from "./VendasPeriodo.vue?vue&type=style&index=0&id=3a497c6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a497c6c",
  null
  
)

export default component.exports